import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { UsdCurrencyPipe } from '../pipes/usd-currency.pipe';

export interface WaiveFeeDialogData { type: string; amount: number; }
export interface WaiveFeeDialogResult { reason: string; }

@Component({
  selector: 'app-waive-fee-dialog',
  standalone: true,
  imports: [CommonModule, UsdCurrencyPipe, ReactiveFormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, MatIconModule],
  template: `
    <h2 mat-dialog-title><mat-icon>remove_circle_outline</mat-icon> Waive fee</h2>
    <mat-dialog-content [formGroup]="form">
      <p>Record why this assessed fee is being waived. This action is audit logged.</p>
      <div class="fee-summary"><span>{{ data.type }} fee</span><strong>{{ data.amount | usdCurrency }}</strong></div>
      <mat-form-field appearance="outline"><mat-label>Waiver reason</mat-label>
        <textarea matInput formControlName="reason" rows="3" required></textarea>
        <mat-error>A waiver reason is required.</mat-error>
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end"><button mat-button [disabled]="submitting" (click)="close()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="form.invalid || submitting" (click)="submit()">{{ submitting ? 'Waiving…' : 'Waive fee' }}</button>
    </mat-dialog-actions>`,
  styles: [`mat-dialog-content{min-width:360px}h2{display:flex;gap:8px;align-items:center}.fee-summary{display:flex;justify-content:space-between;padding:12px;margin:12px 0;background:var(--ifq-gold-tint);border-radius:8px}mat-form-field{width:100%}`]
})
export class WaiveFeeDialogComponent {
  submitting = false;
  form;
  constructor(private fb: FormBuilder, private ref: MatDialogRef<WaiveFeeDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: WaiveFeeDialogData) {
    this.form = this.fb.group({ reason: ['', [Validators.required, Validators.pattern(/\S/)]] });
  }
  submit(): void { if (this.form.invalid) { this.form.markAllAsTouched(); return; } this.submitting = true; this.ref.close({ reason: this.form.value.reason!.trim() }); }
  close(): void { this.ref.close(); }
}
